
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clearance-sale",
      function () {
        return require("private-next-pages/clearance-sale.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clearance-sale"])
      });
    }
  